import { useState } from "react";

export interface StudioPanels {
  showResources: boolean;
  setShowResources: (value: boolean) => void;
  /** The "poof" Details view (about, links, resources, summary). Reachable from
   * the calm pre/post-conversation start screen via the right-edge tab. */
  showDetails: boolean;
  setShowDetails: (value: boolean) => void;
  /** The end-of-conversation wrap-up: recap, soft capture, next steps, app hand-off. */
  showWrapUp: boolean;
  setShowWrapUp: (value: boolean) => void;
  mobileDrawerOpen: boolean;
  setMobileDrawerOpen: (value: boolean) => void;
}

/** Grouped visibility state for the page's overlay panels — no cross-panel logic. */
export function useStudioPanels(): StudioPanels {
  const [showResources, setShowResources] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showWrapUp, setShowWrapUp] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  return {
    showResources,
    setShowResources,
    showDetails,
    setShowDetails,
    showWrapUp,
    setShowWrapUp,
    mobileDrawerOpen,
    setMobileDrawerOpen,
  };
}
